<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintNumber border_bottom">
          <div class="left">投诉单号</div>
          <div class="right">{{itemList.mainComplainNumber}}</div>
        </div>
        <div class="complaintObject border_bottom">
          <div class="left">操作人</div>
          <div class="right">{{checkPerson.depts[0].orgName}}-{{checkPerson.userInfo.name}}</div>
        </div>
        <!-- <div class="whetherApplyAplitting border_bottom" v-show="userInfo.depts[0]&&userInfo.depts[0].txId!= '34'"> -->
           <div class="whetherApplyAplitting border_bottom" v-if="checkPerson.depts[0].areaLevel!=1">
          <div class="left">是否申请拆单</div>
          <div class="right">
            <van-RadioGroup
              v-model="isSplit"
              style="display:flex;margin-top:15px;justify-content:space-around"
            >
              <van-Radio name="1">是</van-Radio>
              <van-Radio name="0">否</van-Radio>
            </van-RadioGroup>
          </div>
        </div>
      </div>
      <div class="remark" v-if="isSplit==1&&checkPerson.depts[0].areaLevel!=1">
        <div class="titleName">申请拆单原因</div>
        <div class="notAccepted">
          <van-field placeholder="请输入办理要求..." type="textarea" maxlength="500" v-model="value1" @input="change1"/>
          <span class="total">{{currentTotal1}}/500</span>
        </div>
      </div>
      <div class="remark">
        <div class="titleName">办理要求</div>
        <div class="notAccepted">
          <van-field placeholder="请输入办理要求..." type="textarea" maxlength="500" @input="change" v-model="value"/>
          <span class="total">{{currentTotal}}/500</span>
        </div>
        <div v-if="type&&type.length>0">
          <div class="jigou" v-for="(item,index) in type" :key="index" @click="remove(index)">
                <div class="left">
                      <span>指挥中心:</span>
                      <span>{{item.name}}</span>
                </div>
                <span class="right">删除</span>
            </div>
        </div>

        <div class="addCommandCenter" @click="$router.push('/complaint/addCommandCenter')" v-show="isShow">添加指挥中心</div>
      </div>
      <div class="btn">
        <div class="submit">
          <van-button type="primary"  @click="sent">通过</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import api from '../../../../service/modules/complaintApis';
    import util from '../../../../utils/common'
    export default {
        data () {
            return {
                currentTotal: 0,
                currentTotal1: 0,
                value: '',
                value1: '',
                isSplit: '0', // 是否申请拆单
                checkPerson: this.$store.state.complaint.userInfo||util.getJsonLocal('userInfoComplaint'),
                type: this.$store.state.complaint.addType,
                id: this.$router.currentRoute.query.orderNum,
                orderNum: this.$router.currentRoute.query.orderNum,
                isShow: true,
                isback:this.$store.state.complaint.isBackDetail||util.getJsonLocal('isBack'),
                itemList: util.getJsonLocal('item'),
                flag: false
                // isShowBtn: false
            };
        },
        created () {
        },
         activated () {
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if (from.path === '/complaint/detailList/complaintSheet'||from.path === '/complaint/detailList/writeInfo'||
                from.path === '/complaint/detailList/saveInfo'||from.path === '/complaint/detailList/phoneHistory'||from.path === '/complaint/detailList/timeLine') {
                  vm.value = '';
                  vm.value1 = '';
                  vm.isSplit = '0';
                  vm.type=[];
                  vm.getType();
                }else{
                  vm.type=vm.$store.state.complaint.addType;
                }
            })
        },
        methods: {
            change1 () {
                this.currentTotal1 = this.value1.trim().length;
            },
            change () {
                this.currentTotal = this.value.trim().length;
            },
            remove (index) {
                this.type.splice(index, 1);
                this.$store.commit('complaint/resetType', this.type);
            },
            getType () {
                let params={
                  'mainComplainNumber':this.itemList.mainComplainNumber
                }
                api.worker.getCenter(params).then((res) => {
                    if (res.ret === 0) {
                        const list = [];
                        if (res.data.list.length > 0) {
                            res.data.list.map((item, index) => {
                                list.push({ 'name': item.fullName, 'orgId': item.id })
                            })
                        }
                        this.$store.commit('complaint/getType', list);
                    }
                })
            },
            sent () {
                const arr = [];
                for (var i = 0; i < this.$store.state.complaint.addType.length; i++) {
                    arr.push(this.$store.state.complaint.addType[i].orgId)
                }
                if (this.isSplit === '1' &&this.checkPerson.depts[0].areaLevel!=1 && this.value1.trim().length === 0) {
                    this.$Toast('请填写申请拆单原因');
                    return;
                }
                // else if(arr.length==0){
                //     this.$Toast('请添加指挥中心');
                //     return;
                // }
                let params = {
                    'mainComplainNumber': this.itemList.mainComplainNumber,
                    'complainNumber': this.itemList.complainNumber,
                    'id':this.itemList.id,
                    'subId': this.itemList.subId,
                    'subPid': this.itemList.subPid,
                    'orgIds': arr,
                    'require': this.value.trim(),
                    'isApply': this.isSplit,
                    'reason': this.value1.trim()
                }
                // this.isShowBtn = true;
                if (this.flag === false) {
                  this.flag = true;
                  api.worker.verifyAgree(params).then((res) => {
                      if (res.ret === 0) {
                          this.$Toast('操作成功');
                          this.$router.back();
                          // this.isShowBtn = false;
                      }
                  })
                }
            }
        }
    };
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  height: 100%;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .complaintInformation {
      width: 100%;
      .complaintNumber,
      .complaintObject,
      .whetherApplyAplitting {
        display: flex;
        height: 50px;
        line-height: 50px;
        .left {
          float: left;
          width: 30%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 70%;
          text-align: right;
          white-space: nowrap;
          overflow: hidden;
          text-overflow:ellipsis;
        }
      }
      .complaintNumber {
        .right {
          color: blue;
        }
      }
    }
    .remark {
      width: 100%;
      margin-top: 20px;
      padding-bottom: 20px;
      .titleName {
        color: #aaa;
        text-align: left;
      }
      .notAccepted {
        margin-top: 14px;
        position: relative;
        .van-cell {
          font-size: 12px;
          background: #efeded;
          border-radius: 7px;
        }
        .total{
              position: absolute;
              bottom:6px;
              right:6px;
          }
      }
      .jigou{
        width:100%;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        margin-top:30px;
        .right{
          padding:8px 16px;
          background-color: @base-color;
          border-radius: 4px;
          color:#fff;
        }
        span{
          color:#aaa;
        }
      }
      .addCommandCenter {
          width: 70%;
          margin-left: 15%;
          font-size: 14px;
          height: 45px;
          line-height: 45px;
          color: #bbb;
          border: #ccc dashed 1px;
          text-align: center;
          margin-top: 30px;
      }
    }
    .companyName {
      height: 50px;
      line-height: 50px;
    }
    .emergencyLevel {
      width: 100%;
      height: 50px;
      line-height: 50px;
    }
    .btn {
      margin-top: 14px;
      .van-button {
        width: 100%;
        border-radius: 7px;
      }
      .back {
        .van-button {
          color: #bdb8b8;
        }
        .van-button--plain {
          background-color: #efeded;
        }
      }
    }
    .border_bottom {
      border-bottom: 1px solid #eee;
    }
  }
}
</style>
